import classNames from "classnames";
import * as React from "react";
import { CssProps, extractCssProps } from "~/sharedComponents/layout/cssProps";

export const createdStyledElement = ({
    /**
     * Name of the component
     */
    name = "",
    /**
     * Default styled props for this component
     */
    defaultCssProps = {} as CssProps,
    /**
     * Default class name for this component
     */
    className = null as string,
}) => {
    type Props = CssProps & {
        tag?: keyof JSX.IntrinsicElements;
        "data-testid"?: string;
        tabIndex?: number;
    } & React.HTMLProps<HTMLElement>;

    const Component = React.forwardRef<HTMLElement, Props>(({ tag = "div", ...allProps }, ref) => {
        const { cssClass, style, props } = extractCssProps(allProps);
        const css = classNames(cssClass, className, props.className);

        const Tag = tag as "div";
        return (
            <Tag
                {...props}
                style={style}
                className={css}
                ref={ref as any}
                tabIndex={allProps.tabIndex}
                data-testid={allProps["data-testid"]}
            />
        );
    });

    Component.displayName = name;
    Component.defaultProps = defaultCssProps;

    return Component;
};
